import { Injectable } from '@angular/core';
import { AuthenticationService } from './authentication.service';

@Injectable()
export class StartupService {
    /**
     * Constructor
     */
    constructor(private authenticationService: AuthenticationService) {}

    /**
     * Startup: load initial app data
     */
    public startup() {
        return new Promise((resolve, reject) => {
            this.authenticationService
                .refreshToken()
                .subscribe()
                .add(resolve);
        });
    }
}
